module.exports = __webpack_public_path__ + "static/media/ff-mark-pro.340249f0.woff";